import React, { useRef, useEffect } from 'react';
import { gsap } from '../../lib/gsapSetup';
import Accordion from '../ui/Accordion';
import { useTranslation } from '../../i18n/LanguageContext';

export default function FAQ() {
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const { t } = useTranslation();

  const FAQ_ITEMS = [
    { question: t('faq.0.q'), answer: t('faq.0.a') },
    { question: t('faq.1.q'), answer: t('faq.1.a') },
    { question: t('faq.2.q'), answer: t('faq.2.a') },
    { question: t('faq.3.q'), answer: t('faq.3.a') },
    { question: t('faq.4.q'), answer: t('faq.4.a') },
    { question: t('faq.5.q'), answer: t('faq.5.a') },
    { question: t('faq.6.q'), answer: t('faq.6.a') },
  ];

  useEffect(() => {
    if (!sectionRef.current) return;

    const ctx = gsap.context(() => {
      if (headingRef.current) {
        gsap.fromTo(
          headingRef.current,
          { opacity: 0, y: 40 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power3.out',
            scrollTrigger: { trigger: headingRef.current, start: 'top 85%' },
          },
        );
      }

      // Accordion container fade in
      const accordion = sectionRef.current.querySelector('.faq-container');
      if (accordion) {
        gsap.fromTo(
          accordion,
          { opacity: 0, y: 40 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            scrollTrigger: { trigger: accordion, start: 'top 85%' },
          },
        );
      }
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      id='faq'
      className='relative py-32 lg:py-40 bg-linx-surface-2'
    >
      <div className='section-container'>
        <div className='mb-16 lg:mb-20'>
          <span className='inline-block font-mono text-xs text-secondary-dark tracking-[0.2em] uppercase mb-4 opacity-80'>
            {t('faq.label')}
          </span>
          <h2
            ref={headingRef}
            className='font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-primary'
            aria-label={t('faq.heading')}
          >
            {t('faq.heading')}
          </h2>
        </div>

        <div className='faq-container max-w-3xl'>
          <Accordion items={FAQ_ITEMS} />

          <div className='mt-12'>
            <p className='text-sm text-linx_text-muted'>
              {t('faq.notFound')}{' '}
              <a
                href='mailto:contact@agodevsolutions.com'
                className='text-secondary-dark hover:text-secondary transition-colors underline underline-offset-4 decoration-secondary/30'
              >
                {t('faq.contact')}
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
